import {
    FOOTER_SIGNUP_DONE
} from '../constants';

const initState = {
    signupDone: false   
}

export const footer = (state = initState, action) => {
    switch (action.type) {
        case FOOTER_SIGNUP_DONE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
